/**

@module

## Anatomy

```jsx
import {
  InlinePopoverPopup,
  InlinePopoverPositioner,
  InlinePopoverRoot,
} from 'prosekit/react/inline-popover'

<InlinePopoverRoot>
  <InlinePopoverPositioner>
    <InlinePopoverPopup>...</InlinePopoverPopup>
  </InlinePopoverPositioner>
</InlinePopoverRoot>
```
*/

'use client'

export * from './index.gen.ts'
